import { render, staticRenderFns } from "./ConfirmChangePassword.vue?vue&type=template&id=1e227a23"
import script from "./ConfirmChangePassword.vue?vue&type=script&lang=js"
export * from "./ConfirmChangePassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports